/* eslint-disable */
import { ref } from 'vue';
import { 
  collection, 
  addDoc, 
  serverTimestamp, 
  doc, 
  updateDoc, 
  increment,
  query,
  where,
  getDocs,
  writeBatch,
  getDoc  // getDoc'u ekledik
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // Auth import'u ekledik
import { db } from '../firebase';

export const useSendMessage = () => {
  const error = ref(null)
  const isPending = ref(false)
  const auth = getAuth() // Auth'u buraya ekleyelim
  const messages = ref([]); // messages array'ini ekleyelim

  const sendMessage = async (messageData) => {
    isPending.value = true
    error.value = null

    try {
        let conversationId = messageData.conversationId;
        let conversationRef;

        // Eğer conversationId yoksa, yeni konuşma oluşturma senaryosu
        if (!conversationId) {
            // Mevcut konuşmayı ara
            const conversationsRef = collection(db, 'conversations');
            const q = query(
                conversationsRef,
                where('participants', 'array-contains', auth.currentUser.uid),
                where('adId', '==', messageData.adId)
            );

            const querySnapshot = await getDocs(q);
            let existingConversation = null;

            // Gelen sonuçlar içinde hem alıcı hem gönderici olan konuşmayı bul
            querySnapshot.forEach((doc) => {
                const convData = doc.data();
                if (convData.participants.includes(messageData.receiverId)) {
                    existingConversation = { id: doc.id, ...convData };
                }
            });

            if (existingConversation) {
                // Mevcut konuşmayı kullan
                conversationId = existingConversation.id;
                conversationRef = doc(db, 'conversations', conversationId);
            } else {
                // Yeni konuşma oluştur
                console.log('Yeni konuşma oluşturuluyor...');
                console.log(messageData);
                const newConversationRef = await addDoc(collection(db, 'conversations'), {
                    participants: [auth.currentUser.uid, messageData.receiverId],
                    adId: messageData.adId,
                    adTitle: messageData.adTitle,
                    coverImage: messageData.coverImage,
                    createdAt: serverTimestamp(),
                    lastMessage: messageData.message,
                    lastMessageTime: serverTimestamp(),
                    lastMessageSenderId: auth.currentUser.uid,
                    lastMessageRead: false,
                    hasUnread: true,
                    sender: {
                        id: messageData.senderId,
                        name: messageData.senderName || 'Unknown User',
                        email: messageData.senderEmail || '',
                        photoURL: messageData.senderPhotoURL || '/default-avatar.png'
                    },
                    receiver: {  // "reciever" yerine "receiver"
                        id: messageData.receiverId, // "rreceiverId" yerine "receiverId"
                        name: messageData.recieverName || 'Unknown User',
                        email: messageData.recieverEmail || '',
                        photoURL: messageData.recieverPhotoURL || '/default-avatar.png'
                    }
                });

                conversationId = newConversationRef.id;
                conversationRef = newConversationRef;
            }

            // messageData'ya conversationId'yi ekle
            messageData.conversationId = conversationId;
        } else {
            // Mevcut conversation için referans al
            conversationRef = doc(db, 'conversations', messageData.conversationId);
            const conversationDoc = await getDoc(conversationRef);

            if (!conversationDoc.exists()) {
                throw new Error('Conversation not found');
            }

            // Kullanıcı yetkisi ve ilan kontrolü
            const conversationData = conversationDoc.data();
            if (!conversationData.participants?.includes(auth.currentUser?.uid)) {
                throw new Error('You do not have permission to send messages in this conversation');
            }

            // İlan ID kontrolü ekleyelim
            if (conversationData.adId !== messageData.adId) {
                // Eğer ilan ID'leri uyuşmuyorsa, yeni bir konuşma başlatmalıyız
                // Mevcut konuşmayı ara
                const conversationsRef = collection(db, 'conversations');
                const q = query(
                    conversationsRef,
                    where('participants', 'array-contains', auth.currentUser.uid),
                    where('adId', '==', messageData.adId)
                );

                const querySnapshot = await getDocs(q);
                let existingConversation = null;

                // Gelen sonuçlar içinde hem alıcı hem gönderici olan konuşmayı bul
                querySnapshot.forEach((doc) => {
                    const convData = doc.data();
                    if (convData.participants.includes(messageData.receiverId)) {
                        existingConversation = { id: doc.id, ...convData };
                    }
                });

                if (existingConversation) {
                    // Mevcut konuşmayı kullan
                    conversationId = existingConversation.id;
                    conversationRef = doc(db, 'conversations', conversationId);
                } else {
                    // Yeni konuşma oluştur
                    const newConversationRef = await addDoc(collection(db, 'conversations'), {
                        participants: [auth.currentUser.uid, messageData.receiverId],
                        adId: messageData.adId,
                        adTitle: messageData.adTitle,
                        coverImage: messageData.coverImage,
                        createdAt: serverTimestamp(),
                        lastMessage: messageData.message,
                        lastMessageTime: serverTimestamp(),
                        lastMessageSenderId: auth.currentUser.uid,
                        lastMessageRead: false,
                        hasUnread: true
                    });

                    conversationId = newConversationRef.id;
                    conversationRef = newConversationRef;
                }

                // messageData'ya yeni conversationId'yi ekle
                messageData.conversationId = conversationId;
            }
        }

        // Mesajı gönder
        const messagesRef = collection(db, 'conversations', conversationId, 'messages');
        const newMessageRef = await addDoc(messagesRef, {
            message: messageData.message,
            senderId: messageData.senderId,
            senderName: messageData.senderName || 'Unknown User',
            senderEmail: messageData.senderEmail || '',
            senderPhotoURL: messageData.senderPhotoURL || '/default-avatar.png',
            receiverId: messageData.receiverId,
            receiverName: messageData.receiverName || 'Unknown User',
            receiverEmail: messageData.receiverEmail || '',
            receiverPhotoURL: messageData.receiverPhotoURL || '/default-avatar.png', // "receiver" olarak düzeltildi
            createdAt: serverTimestamp(),
            isRead: false
        });

        // Unread messages array'ine ekle
        const unreadMessagesRef = doc(db, 'unread_messages', messageData.receiverId);
        const unreadMessagesDoc = await getDoc(unreadMessagesRef);
        const batch = writeBatch(db);

        if (unreadMessagesDoc.exists()) {
            // Mevcut array'i al
            const currentUnreadMessages = unreadMessagesDoc.data().unreadMessageId || [];
            
            // Yeni mesaj ID'si array'de var mı kontrol et
            if (!currentUnreadMessages.includes(newMessageRef.id)) {
                // Mesaj ID'si yoksa ekle
                batch.update(unreadMessagesRef, {
                    unreadMessageId: [...currentUnreadMessages, newMessageRef.id]
                });
                console.log(`Yeni okunmamış mesaj eklendi: ${newMessageRef.id}`);
            } else {
                console.log(`Mesaj zaten okunmamışlar listesinde: ${newMessageRef.id}`);
            }
        } else {
            // Döküman yoksa yeni oluştur
            batch.set(unreadMessagesRef, {
                unreadMessageId: [newMessageRef.id]
            });
            console.log(`Yeni okunmamış mesajlar dökümanı oluşturuldu: ${newMessageRef.id}`);
        }

        // Conversation'ı güncelle
        batch.update(conversationRef, {
            lastMessage: messageData.message,
            lastMessageTime: serverTimestamp(),
            lastMessageSenderId: auth.currentUser.uid,
            lastMessageRead: false,
            hasUnread: true
        });

        await batch.commit();

        // Yeni mesajı UI'a ekle
        const newMessage = {
            id: newMessageRef.id,
            ...messageData,
            createdAt: {
                toDate: () => new Date(),
                toMillis: () => Date.now()
            },
            isRead: false,
            isNew: true
        };
        messages.value = [...messages.value, newMessage];

        return true;
    } catch (err) {
        console.error('Error sending message:', err);
        error.value = err.message;
        return false;
    } finally {
        isPending.value = false;
    }
};

  return { sendMessage, error, isPending, messages };
};
